/**
 * @generated SignedSource<<009674ce2d6c90eed39751f4f6365ac7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printfulAuthUrlQuery$variables = Record<PropertyKey, never>;
export type printfulAuthUrlQuery$data = {
  readonly printfulAuthUrl: string | null;
};
export type printfulAuthUrlQuery = {
  response: printfulAuthUrlQuery$data;
  variables: printfulAuthUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "printfulAuthUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "printfulAuthUrlQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "printfulAuthUrlQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "870277db89f678bcb729e1d9f82ca7d7",
    "id": null,
    "metadata": {},
    "name": "printfulAuthUrlQuery",
    "operationKind": "query",
    "text": "query printfulAuthUrlQuery {\n  printfulAuthUrl\n}\n"
  }
};
})();

(node as any).hash = "412e461b987c7668370c9b7baf742355";

export default node;
